const UK_POSTCODE_PATTERN = /^(GIR ?0AA|[A-Z]{1,2}\d[\dA-Z]? ?\d[A-Z]{2})$/;

export function isUkCountry(country: string): boolean {
  return country === "UK" || country === "United Kingdom";
}

export function normalizeUkPostcode(value: string): string {
  const compact = value
    .normalize("NFKC")
    .replace(/[\s\uFEFF]+/gu, "")
    .toUpperCase();

  if (compact.length <= 3) {
    return compact;
  }

  return `${compact.slice(0, -3)} ${compact.slice(-3)}`;
}

export function normalizePostcodeForCountry(
  value: string,
  country: string,
): string {
  return isUkCountry(country) ? normalizeUkPostcode(value) : value;
}

export function isValidPostcodeForCountry(
  value: string,
  country: string,
): boolean {
  if (!isUkCountry(country)) {
    return true;
  }

  return UK_POSTCODE_PATTERN.test(normalizeUkPostcode(value));
}
